import { render, staticRenderFns } from "./Prosepcts.vue?vue&type=template&id=204b9845&"
import script from "./Prosepcts.vue?vue&type=script&lang=js&"
export * from "./Prosepcts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports